export const RADIUS = 4;

export const BACKGROUND_UNFOCUSED_OPACITY = 0;

export const ICON_BACKGROUND_UNFOCUSED_OPACITY = 0.2;

export const FOCUSED_FONT = 'KINSHASA_1';

export const UNFOCUSED_FONT = 'KINSHASA_1';
